import React from 'react';
import styles from './estimateListItem.module.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';

/** 내 견적 목록의 한 행. 클릭하면 상세(수정) 화면으로 이동한다. */
const EstimateListItem = (props) => {
  const navigate = useNavigate();
  const { page } = useParams();
  const { state } = useLocation();

  const handleClickListItem = () => {
    navigate(`/my/list/${page}/${props.id}`, { state: { form: state?.form } });
  };

  return (
    <li className={styles.estimateListItem} onClick={handleClickListItem}>
      <Box className={styles.id}>{props.id}</Box>
      <Box
        className={`${styles.name} ${props.estimateType === '통근' ? styles.commute : styles.normal}`}
      >
        {props.estimateType === '통근' ? '통근' : '일반'}
      </Box>
      <Box className={styles.travelType}>{props.travelType}</Box>
      <Box className={styles.departPlace}>{props.departPlace}</Box>
      <Box className={styles.arrivalPlace}>{props.arrivalPlace}</Box>
      <Box className={styles.vehicleType}>{props.vehicleType}</Box>
      <Box className={styles.createdDate}>{String(props.createdDate ?? '').substring(0, 10)}</Box>
    </li>
  );
};

export default EstimateListItem;
